import { atom } from 'jotai';

export type LinkedOrderType = 'purchaseOrder' | 'salesOrder';

export const $linkedOrdersSelectedType = atom<LinkedOrderType | null>(null);
export const $linkedOrdersSelectedId = atom<string | null>(null);
export const $linkedOrdersSearchTerm = atom<string>('');
